<template>
  <div class="tab-container paddT80 bg-white">
    <div class="call-us">
      <img src="../../assets/images/about-us/call-us/logo.png"
           alt="">
      <div class="call-us-info">
        <img src="../../assets/images/about-us/call-us/code4.png"
             alt="">
        <div>
          <p>电话：020-37209386</p>
          <p>传真：020-37209386</p>
          <p>邮箱：elvyoo@elvyoo.com</p>
          <p>地址：广州市海珠区新港东路238号海珠创意园F1栋5楼</p>
        </div>
      </div>

    </div>
    <div class="map-box">
      <img src="../../assets/images/about-us/call-us/map.png"
           alt="">
    </div>
    <div class="call-man">
      <div class="call-man-box">
        <div class="man-box-item">
          <img src="../../assets/images/about-us/call-us/code3.png"
               alt="">
          <p>赖先生</p>
          <p>18688907159</p>
        </div>
        <div class="man-box-item">
          <img src="../../assets/images/about-us/call-us/code2.png"
               alt="">
          <p>骆先生</p>
          <p>13928799037</p>
        </div>
        <div class="man-box-item">
          <img src="../../assets/images/about-us/call-us/code1.png"
               alt="">

          <p>刘先生</p>
          <p>13926477660</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data () {
    return {

    }
  }
}
</script>
<style  scoped>
.tab-container {
  height: 100%;
}
.call-us {
  width: 11.6rem;
  height: 2rem;
  background: #e6e6e6 !important;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.4rem;
  box-sizing: border-box;
}

.call-us > img:nth-child(1) {
  width: 4.5rem;
}

.call-us > div > p {
  font-size: 0.16rem;
  line-height: 0.32rem;
  color: #4d4d4d;
}
.map-box {
  width: 11.6rem;
  height: 5.4rem;
  margin: auto;
}
.map-box > img {
  width: 100%;
}
.call-man {
  width: 100%;
  height: 3.56rem;
  /* background: rgba(228, 228, 228, 1); */
  margin-top: 0.8rem;
  background-image: url("../../assets/images/about-us/call-us/hand.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
}
.call-man-box {
  display: flex;
  align-items: center;
  width: 11.6rem;
  margin: auto;
  justify-content: flex-end;
}
.man-box-item {
  text-align: center;
}
.man-box-item > img {
  width: 1.8rem;
  height: 1.8rem;
}
.man-box-item:nth-child(2) {
  margin: 0 0.4rem !important;
}
.man-box-item > p:nth-child(2) {
  color: #4d4d4d;
  font-size: 0.2rem;
  text-align: center;
}
.man-box-item > p:nth-child(3) {
  font-weight: bold;
  color: #4d4d4d;
  line-height: 0.32rem;
  font-size: 0.2rem;
  text-align: center;
}
.call-us-info {
  display: flex;
  align-items: center;
}
.call-us-info > img {
  width: 1.2rem;
  width: 1.2rem;
  margin-right: 0.2rem;
}
.call-us-info > div {
  font-size: 0.16rem;
  line-height: 0.32rem;
  color: #4d4d4d;
}
</style>